/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  initNewsletterActiveState();
  initFooterMenuHover();
  initMobileMenuAccordion();
});

function initMobileMenuAccordion() {
  $('.desk_footer-mobile-menu-item').on('click', function (e) {
    if ($(e.target).closest('a').length) {
      return;
    }
    toggleMobileMenuItem($(this));
  });
}

function toggleMobileMenuItem($item) {
  // Close any other open item — only one can be open at a time.
  $('.desk_footer-mobile-menu-item.active').not($item).each(function () {
    $(this).removeClass('active');
    $(this).find('.desk_footer-mobile-menu-links_out').slideUp(300);
  });

  $item.toggleClass('active');
  $item.find('.desk_footer-mobile-menu-links_out').slideToggle(300);
}

function initFooterMenuHover() {
  // The Info block uses a plain per-link hover (no dim-siblings) — skip the `.hovered` class there.
  $('.desk_footer-menu-links').on('mouseenter', 'a', function () {
    if ($(this).closest('.desk_footer-menu-box--info').length) return;
    $(this).closest('.desk_footer-menu-links').addClass('hovered');
  });

  $('.desk_footer-menu-links').on('mouseleave', 'a', function () {
    if ($(this).closest('.desk_footer-menu-box--info').length) return;
    $(this).closest('.desk_footer-menu-links').removeClass('hovered');
  });

  $('.desk_footer-veryfooter-line').on('mouseenter', 'a', function () {
    $(this).closest('.desk_footer-veryfooter-line').addClass('hovered');
  });

  $('.desk_footer-veryfooter-line').on('mouseleave', 'a', function () {
    $(this).closest('.desk_footer-veryfooter-line').removeClass('hovered');
  });
}

function initNewsletterActiveState() {
  var $forms = $('.newsletter-form');

  $forms.on('click', function () {
    activateForm($(this));
  });

  $(document).on('click', function (e) {
    handleOutsideClick($forms, e.target);
  });

  // Prefilled fields (after submit, restore, autofill) need the active state too
  activateFilledForms($forms);
  $(window).on('load', function () {
    activateFilledForms($forms);
  });
  $forms.on('input change', 'input, textarea', function () {
    activateFilledForms($forms);
  });
}

function activateFilledForms($forms) {
  $forms.each(function () {
    if (formHasValue($(this))) {
      activateForm($(this));
    }
  });
}

function activateForm($form) {
  $form.addClass('activeNow');
}

function handleOutsideClick($forms, target) {
  $forms.each(function () {
    var $form = $(this);

    if (isClickInside($form, target)) {
      return;
    }

    if (!formHasValue($form)) {
      $form.removeClass('activeNow');
    }
  });
}

function isClickInside($form, target) {
  return $form.is(target) || $form.has(target).length > 0;
}

function formHasValue($form) {
  var hasValue = false;

  $form.find('input, textarea').not('[type="hidden"]').each(function () {
    if ($.trim($(this).val()) !== '') {
      hasValue = true;
      return false;
    }
  });

  return hasValue;
}
